import Field from "./field";

export default class Form {
	constructor({ id_form, name, event, rates, form_fields }) {
		this._id_form = parseInt(id_form);
		this._name = name;
		this._event = event;
		this._rates = rates;
		this._form_fields = form_fields.map(field => new Field(field, id_form));
	}

	id() {
		return this._id_form;
	}

	name() {
		return this._name;
	}

	event() {
		return this._event;
	}

	rates() {
		return this._rates;
	}

	formFields() {
		return this._form_fields;
	}

	getFormByQuestion(questionId) {
		let form = this._form_fields.find(field => field.id() === questionId);
		if (form) {
			return form;
		}
		return null;
	}
}
